import(/* webpackMode: "eager" */ "/workspace/web-admin/app/(dashboard)/page.tsx");
